import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import MenuDialog from './menudialog';

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const styles = theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
});

class TabsWrappedLabel extends React.Component {
  state = {
    value: 'one',
  };

  Spares = event => {
    let value = event.target.value;
    let partno = value.split('->')[0];
    let spareName = value.split('->')[1];
    this.setState({ title: spareName, value: partno })
  }

  render() {
    const { classes } = this.props;
    const { value } = this.state;
    return (
      <div>
        { this.props.menuPermission.edit ?
          (
          <div align='right'>
            <div style={{display: 'flex'}}>
              <div style={{marginRight: 5}}>
                <datalist id="suggestions">
                    {this.props.spareOption.map((x) => {
                      return (
                        <option id='box'>{x.text}</option>
                      )
                    })}
                </datalist>
                <input style={{height: 35, width: '100%', display: this.props.partsedit}} onChange={this.Spares} autoComplete="on"
                list="suggestions" value={this.state.dropdown}/>
              </div>
              <div>
                <MenuDialog menus={this.props.menus} datas={this.props.datas} partsedit={this.props.partsedit} partno={this.state.value} title={this.state.title} />
              </div>
            </div>
          </div>
          ):''
        }
      </div>
    );
  }
}

TabsWrappedLabel.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TabsWrappedLabel);
